import * as i0 from '@angular/core';
import { inject, ElementRef, Directive, signal, Injectable, InjectionToken, NgZone, input, booleanAttribute, numberAttribute, computed, output, afterRenderEffect, untracked, effect, PLATFORM_ID, Component, ChangeDetectionStrategy, viewChild, Renderer2, ApplicationRef, linkedSignal, contentChild, createComponent, Injector, NgModule, makeEnvironmentProviders } from '@angular/core';
import { tap, throttleTime, combineLatest, fromEvent, map, merge, startWith, switchMap, takeUntil, delay, EMPTY, takeWhile, from, of, interval, animationFrameScheduler } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { Directionality } from '@angular/cdk/bidi';
import { SharedResizeObserver } from '@angular/cdk/observers/private';
import { toSignal } from '@angular/core/rxjs-interop';
import { SmoothScrollManager } from 'ngx-scrollbar/smooth-scroll';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ContentObserver } from '@angular/cdk/observers';
const _c0 = ["scrollbarButton", ""];
function ScrollbarY_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 4)(1, "button", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-button ", ctx_r0.cmp.buttonClass()));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-button ", ctx_r0.cmp.buttonClass()));
  }
}
function ScrollbarX_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 4)(1, "button", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-button ", ctx_r0.cmp.buttonClass()));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-button ", ctx_r0.cmp.buttonClass()));
  }
}
const _c1 = "[_nghost-%COMP%]{position:absolute;inset:0;pointer-events:none;min-width:calc(var(--viewport-width) * 1px);min-height:calc(var(--viewport-height) * 1px)}.ng-scrollbar-sticky[_ngcontent-%COMP%]{top:calc(var(--_scrollbar-wrapper-top) * 1px);left:calc(var(--_scrollbar-wrapper-left) * 1px);right:calc(var(--_scrollbar-wrapper-right) * 1px);height:calc(var(--_scrollbar-wrapper-height) * 1px);width:calc(var(--_scrollbar-wrapper-width) * 1px);position:sticky;z-index:100;opacity:var(--_scrollbar-hover-opacity);transition:var(--_scrollbar-opacity-transition);pointer-events:var(--_scrollbar-pointer-events)}.ng-scrollbar-track-wrapper[_ngcontent-%COMP%]{touch-action:none;-webkit-user-select:none;user-select:none;top:var(--_scrollbar-track-top);bottom:var(--_scrollbar-track-bottom);right:var(--_scrollbar-track-right);left:var(--_scrollbar-track-left);transition:var(--INTERNAL-scrollbar-track-wrapper-transition);position:absolute;overflow:hidden;display:flex;place-items:center}.ng-scrollbar-track[_ngcontent-%COMP%]{position:relative;width:100%;height:100%;background-color:var(--INTERNAL-scrollbar-track-color);border-radius:var(--INTERNAL-scrollbar-border-radius);cursor:default;z-index:1;order:2}.ng-scrollbar-thumb[_ngcontent-%COMP%]{box-sizing:border-box;position:absolute;transition:var(--INTERNAL-scrollbar-thumb-transition);border-radius:var(--INTERNAL-scrollbar-border-radius);height:var(--_thumb-height);width:var(--_thumb-width);animation-name:_ngcontent-%COMP%_scrollbarThumbAnimation;animation-duration:1ms;animation-timing-function:linear}@keyframes _ngcontent-%COMP%_scrollbarThumbAnimation{0%{translate:var(--_scrollbar-thumb-transform-from)}to{translate:var(--_scrollbar-thumb-transform-to)}}";
function Scrollbars_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "scrollbar-y");
  }
}
function Scrollbars_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "scrollbar-x");
  }
}
const _c2 = ["contentWrapper"];
const _c3 = ["*"];
const _c4 = ["externalViewport", ""];
const _c5 = "[_nghost-%COMP%]{display:block;position:relative;max-height:100%;max-width:100%;--INTERNAL-scrollbar-border-radius: var(--scrollbar-border-radius, 0px);--INTERNAL-scrollbar-thickness: var(--scrollbar-thickness, 5);--INTERNAL-scrollbar-offset: var(--scrollbar-offset, 0);--INTERNAL-scrollbar-track-wrapper-transition: var(--scrollbar-track-wrapper-transition, width 60ms linear, height 60ms linear);--INTERNAL-scrollbar-track-color: var(--scrollbar-track-color, transparent);--INTERNAL-scrollbar-thumb-color: var(--scrollbar-thumb-color, rgb(0 0 0 / 20%));--INTERNAL-scrollbar-thumb-hover-color: var(--scrollbar-thumb-hover-color, var(--INTERNAL-scrollbar-thumb-color));--INTERNAL-scrollbar-hover-thickness: var(--scrollbar-hover-thickness, var(--INTERNAL-scrollbar-thickness));--INTERNAL-scrollbar-thumb-transition: var(--scrollbar-thumb-transition, none);--INTERNAL-scrollbar-thumb-min-size: var(--scrollbar-thumb-min-size, 20);--INTERNAL-scrollbar-button-color: var(--scrollbar-button-color, var(--INTERNAL-scrollbar-thumb-color));--INTERNAL-scrollbar-button-hover-color: var(--scrollbar-button-hover-color, var(--INTERNAL-scrollbar-button-color));--INTERNAL-scrollbar-button-active-color: var(--scrollbar-button-active-color, var(--INTERNAL-scrollbar-button-hover-color));--INTERNAL-scrollbar-button-fill: var(--scrollbar-button-fill, white);--INTERNAL-scrollbar-button-hover-fill: var(--scrollbar-button-hover-fill, var(--INTERNAL-scrollbar-button-fill));--INTERNAL-scrollbar-button-active-fill: var(--scrollbar-button-active-fill, var(--INTERNAL-scrollbar-button-hover-fill));--INTERNAL-scrollbar-button-size: var(--scrollbar-button-size, 20px);--INTERNAL-scrollbar-hover-opacity-transition-enter-duration: var(--scrollbar-hover-opacity-transition-enter-duration, 0);--INTERNAL-scrollbar-hover-opacity-transition-leave-duration: var(--scrollbar-hover-opacity-transition-leave-duration, .4s);--INTERNAL-scrollbar-hover-opacity-transition-leave-delay: var(--scrollbar-hover-opacity-transition-leave-delay, 1s);--INTERNAL-scrollbar-overscroll-behavior: var(--scrollbar-overscroll-behavior, initial);--INTERNAL-scrollbar-mobile-overscroll-behavior: var(--scrollbar-mobile-overscroll-behavior, none);--_scrollbar-thickness: calc(var(--INTERNAL-scrollbar-thickness) + var(--INTERNAL-scrollbar-offset) * 2);--_scrollbar-pointer-events: auto;--_scrollbar-offset-px: calc(var(--INTERNAL-scrollbar-offset) * 1px);--_scrollbar-thickness-px: calc(var(--INTERNAL-scrollbar-thickness) * 1px);--_scrollbar-hover-thickness-px: calc(var(--INTERNAL-scrollbar-hover-thickness) * 1px);--_viewport-padding-top: 0;--_viewport-padding-bottom: 0;--_viewport-padding-left: 0;--_viewport-padding-right: 0;--_horizontal-thumb-display: block;--_vertical-thumb-display: block;--_viewport-overflow: auto;--_viewport-pointer-events: auto;--_thumb-x-color: var(--INTERNAL-scrollbar-thumb-color);--_thumb-y-color: var(--INTERNAL-scrollbar-thumb-color);--_track-y-thickness: var(--_scrollbar-thickness-px);--_track-x-thickness: var(--_scrollbar-thickness-px);--_viewport-overscroll-behavior: var(--INTERNAL-scrollbar-overscroll-behavior);--_scrollbar-content-width: fit-content}[_nghost-%COMP%]{--_spacer-width: var(--spacer-width);--_spacer-height: var(--spacer-height);--_vertical-top: var(--_scrollbar-offset-px);--_vertical-bottom: var(--_scrollbar-offset-px);--_horizontal-left: var(--_scrollbar-offset-px);--_horizontal-right: var(--_scrollbar-offset-px);--_horizontal-top: initial;--_horizontal-bottom: var(--_scrollbar-offset-px);--_scrollbar-wrapper-x-top: calc(var(--viewport-height) - var(--_scrollbar-thickness));--reached-offset: 1px;--reached-offset-top: var(--reached-offset);--reached-offset-bottom: var(--reached-offset);--reached-offset-start: var(--reached-offset);--reached-offset-end: var(--reached-offset);--dropped-offset: 1px;--dropped-offset-top: var(--dropped-offset);--dropped-offset-bottom: var(--dropped-offset);--dropped-offset-start: var(--dropped-offset);--dropped-offset-end: var(--dropped-offset);--_viewport_scroll-timeline: unset;--_animation-timeline-y: unset;--_scrollbar-y-thumb-transform-to-value: unset;--_scrollbar-x-thumb-transform-to-value: unset;--_scrollbar-thumb-transform-from: unset;--_scrollbar-thumb-transform-to: unset}.ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport{min-height:100%;min-width:100%;height:100%;max-height:100%;max-width:100%}.ng-scroll-viewport[_nghost-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport{position:relative;overflow:var(--_viewport-overflow);scroll-timeline:var(--_viewport_scroll-timeline);box-sizing:border-box!important;-webkit-overflow-scrolling:touch;will-change:scroll-position;-webkit-user-select:var(--_viewport-user-select);user-select:var(--_viewport-user-select);overscroll-behavior:var(--_viewport-overscroll-behavior);pointer-events:var(--_viewport-pointer-events)}.ng-scroll-viewport[_nghost-%COMP%] > .ng-scroll-content[_ngcontent-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport>.ng-scroll-content{width:var(--_scrollbar-content-width);z-index:1;min-width:100%;min-height:100%;contain:content;padding:var(--_viewport-padding-top, 0) var(--_viewport-padding-right, 0) var(--_viewport-padding-bottom, 0) var(--_viewport-padding-left, 0)}[appearance=native][_nghost-%COMP%]{--_spacer-width: calc(var(--spacer-width) + var(--_scrollbar-thickness));--_spacer-height: calc(var(--spacer-height) + var(--_scrollbar-thickness))}.ng-scroll-viewport[_nghost-%COMP%] > .ng-scroll-spacer[_ngcontent-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport>.ng-scroll-spacer{position:relative;width:calc(var(--_spacer-width) * 1px);height:calc(var(--_spacer-height) * 1px)}.ng-scroll-viewport[_nghost-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport{scrollbar-width:none!important}.ng-scroll-viewport[_nghost-%COMP%]::-webkit-scrollbar, .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport::-webkit-scrollbar{display:none!important}[position=invertX][_nghost-%COMP%], [position=invertAll][_nghost-%COMP%]{--_horizontal-top: var(--_scrollbar-offset-px);--_horizontal-bottom: initial;--_scrollbar-wrapper-x-top: 0}[dir=ltr][_nghost-%COMP%]{--_scrollbar-wrapper-y-right: initial;--_vertical-right: var(--_scrollbar-offset-px);--_vertical-left: initial;--_scrollbar-wrapper-y-left: calc(var(--viewport-width) - var(--_scrollbar-thickness))}[dir=ltr][position=invertY][_nghost-%COMP%], [dir=ltr][position=invertAll][_nghost-%COMP%]{--_vertical-left: var(--_scrollbar-offset-px);--_vertical-right: initial;--_scrollbar-wrapper-y-left: 0}[dir=rtl][_nghost-%COMP%]{--_scrollbar-wrapper-y-left: initial;--_vertical-left: var(--_scrollbar-offset-px);--_vertical-right: initial;--_scrollbar-wrapper-y-right: calc(var(--viewport-width) - var(--_scrollbar-thickness))}[dir=rtl][position=invertY][_nghost-%COMP%], [dir=rtl][position=invertAll][_nghost-%COMP%]{--_vertical-right: var(--_scrollbar-offset-px);--_vertical-left: initial;--_scrollbar-wrapper-y-right: 0}[verticalUsed=true][horizontalUsed=true][_nghost-%COMP%]{--_scrollbar-thickness-margin: calc(var(--INTERNAL-scrollbar-thickness) + var(--INTERNAL-scrollbar-offset) * 3);--_scrollbar-thickness-margin-px: calc(var(--_scrollbar-thickness-margin) * 1px)}[horizontalUsed=true][_nghost-%COMP%]{--_vertical-top: var(--_scrollbar-offset-px);--_vertical-bottom: var(--_scrollbar-thickness-margin-px)}[horizontalUsed=true][position=invertX][_nghost-%COMP%], [horizontalUsed=true][position=invertAll][_nghost-%COMP%]{--_vertical-top: var(--_scrollbar-thickness-margin-px);--_vertical-bottom: var(--_scrollbar-offset-px)}[verticalUsed=true][dir=ltr][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-offset-px);--_horizontal-right: var(--_scrollbar-thickness-margin-px)}[verticalUsed=true][dir=rtl][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-thickness-margin-px);--_horizontal-right: var(--_scrollbar-offset-px)}[verticalUsed=true][position=invertY][dir=ltr][_nghost-%COMP%], [verticalUsed=true][position=invertAll][dir=ltr][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-thickness-margin-px);--_horizontal-right: var(--_scrollbar-offset-px)}[verticalUsed=true][position=invertY][dir=rtl][_nghost-%COMP%], [verticalUsed=true][position=invertAll][dir=rtl][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-offset-px);--_horizontal-right: var(--_scrollbar-thickness-margin-px)}[appearance=native][verticalUsed=true][dir=ltr][_nghost-%COMP%]{--_viewport-padding-left: 0;--_viewport-padding-right: calc(var(--_scrollbar-thickness) * 1px)}[appearance=native][verticalUsed=true][dir=rtl][_nghost-%COMP%]{--_viewport-padding-left: calc(var(--_scrollbar-thickness) * 1px);--_viewport-padding-right: 0}[appearance=native][verticalUsed=true][position=invertY][dir=ltr][_nghost-%COMP%], [appearance=native][verticalUsed=true][position=invertAll][dir=ltr][_nghost-%COMP%]{--_viewport-padding-left: calc(var(--_scrollbar-thickness) * 1px);--_viewport-padding-right: 0}[appearance=native][verticalUsed=true][position=invertY][dir=rtl][_nghost-%COMP%], [appearance=native][verticalUsed=true][position=invertAll][dir=rtl][_nghost-%COMP%]{--_viewport-padding-left: 0;--_viewport-padding-right: calc(var(--_scrollbar-thickness) * 1px)}[appearance=native][horizontalUsed=true][_nghost-%COMP%]{--_viewport-padding-top: 0;--_viewport-padding-bottom: calc(var(--_scrollbar-thickness) * 1px)}[appearance=native][horizontalUsed=true][position=invertX][_nghost-%COMP%], [appearance=native][horizontalUsed=true][position=invertAll][_nghost-%COMP%]{--_viewport-padding-top: calc(var(--_scrollbar-thickness) * 1px);--_viewport-padding-bottom: 0}[visibility=hover][_nghost-%COMP%]{--_scrollbar-hover-opacity: 0;--_scrollbar-opacity-transition: opacity var(--INTERNAL-scrollbar-hover-opacity-transition-leave-duration) var(--INTERNAL-scrollbar-hover-opacity-transition-leave-delay)}[visibility=hover][_nghost-%COMP%]:hover, [visibility=hover][_nghost-%COMP%]:active, [visibility=hover][_nghost-%COMP%]:focus{--_scrollbar-hover-opacity: 1;--_scrollbar-opacity-transition: opacity var(--INTERNAL-scrollbar-hover-opacity-transition-enter-duration)}[dir=ltr][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start], [dir=ltr][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=start]{left:0;right:unset}[dir=ltr][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end], [dir=ltr][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=end]{right:0;left:unset}[dir=rtl][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start], [dir=rtl][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=start]{right:0;left:unset}[dir=rtl][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end], [dir=rtl][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=end]{left:0;right:unset}[_nghost-%COMP%]     .ng-scroll-reached-wrapper, [_nghost-%COMP%]     .ng-scroll-dropped-wrapper, [_nghost-%COMP%]     .scroll-reached-trigger-element, [_nghost-%COMP%]     .scroll-dropped-trigger-element{position:absolute;-webkit-user-select:none;user-select:none;pointer-events:none;z-index:-9999}[_nghost-%COMP%]     .ng-scroll-reached-wrapper, [_nghost-%COMP%]     .ng-scroll-dropped-wrapper{visibility:hidden;inset:0;min-width:calc(var(--viewport-width) * 1px);min-height:calc(var(--viewport-height) * 1px)}[_nghost-%COMP%]     [isHorizontallyScrollable=false] .scroll-reached-trigger-element[trigger=end], [_nghost-%COMP%]     [isHorizontallyScrollable=false] .scroll-dropped-trigger-element[trigger=end]{display:none}[_nghost-%COMP%]     [isVerticallyScrollable=false] .scroll-reached-trigger-element[trigger=bottom], [_nghost-%COMP%]     [isVerticallyScrollable=false] .scroll-dropped-trigger-element[trigger=bottom]{display:none}[_nghost-%COMP%]     .scroll-reached-trigger-element{background:red}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=top], [_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=bottom]{left:0;right:0}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start], [_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end]{top:0;bottom:0}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=top]{top:0;height:var(--reached-offset-top)}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=bottom]{bottom:0;height:var(--reached-offset-bottom)}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start]{width:var(--reached-offset-start)}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end]{width:var(--reached-offset-end)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[_ngcontent-%COMP%]{background:#00f}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=top][_ngcontent-%COMP%], [_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=bottom][_ngcontent-%COMP%]{left:0;right:0}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=start][_ngcontent-%COMP%], [_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=end][_ngcontent-%COMP%]{top:0;bottom:0}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=top][_ngcontent-%COMP%]{top:0;height:var(--dropped-offset-top)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=bottom][_ngcontent-%COMP%]{bottom:0;height:var(--dropped-offset-bottom)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=start][_ngcontent-%COMP%]{width:var(--dropped-offset-start)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=end][_ngcontent-%COMP%]{width:var(--dropped-offset-end)}[verticalUsed=true][_nghost-%COMP%]{--_timeline-scope: --scrollerY;--_animation-timeline-y: --scrollerY;--_viewport_scroll-timeline: --scrollerY y}[horizontalUsed=true][_nghost-%COMP%]{--_timeline-scope: --scrollerX;--_animation-timeline-x: --scrollerX;--_viewport_scroll-timeline: --scrollerX x}[verticalUsed=true][horizontalUsed=true][_nghost-%COMP%]{--_timeline-scope: --scrollerX, --scrollerY;--_viewport_scroll-timeline: --scrollerX x, --scrollerY y}[orientation=vertical][_nghost-%COMP%]{--_viewport-overflow: hidden auto;--_scrollbar-content-width: unset}[orientation=horizontal][_nghost-%COMP%]{--_viewport-overflow: auto hidden}[disableInteraction=true][_nghost-%COMP%]{--_viewport-pointer-events: none;--_scrollbar-pointer-events: none}[isVerticallyScrollable=false][_nghost-%COMP%]{--_vertical-thumb-display: none}[isHorizontallyScrollable=false][_nghost-%COMP%]{--_horizontal-thumb-display: none}[dragging=x][_nghost-%COMP%], [dragging=y][_nghost-%COMP%]{--_viewport-user-select: none}[dragging=x][_nghost-%COMP%]{--_track-x-thickness: calc(var(--INTERNAL-scrollbar-hover-thickness) * 1px);--_thumb-x-color: var(var(--INTERNAL-scrollbar-thumb-min-size))}[dragging=y][_nghost-%COMP%]{--_track-y-thickness: calc(var(--INTERNAL-scrollbar-hover-thickness) * 1px);--_thumb-y-color: var(var(--INTERNAL-scrollbar-thumb-min-size))}[mobile=true][_nghost-%COMP%]{--_viewport-overscroll-behavior: var(--INTERNAL-scrollbar-mobile-overscroll-behavior)}";
let ScrollViewport = /*#__PURE__*/(() => {
  class ScrollViewport {
    constructor() {
      this.nativeElement = inject(ElementRef).nativeElement;
    }
    static {
      this.ɵfac = function ScrollViewport_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollViewport)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ScrollViewport,
        selectors: [["", "scrollViewport", ""]]
      });
    }
  }
  return ScrollViewport;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function preventSelection(doc) {
  return tap(() => doc.onselectstart = () => false);
}
function enableSelection(doc) {
  return tap(() => doc.onselectstart = null);
}
function stopPropagation() {
  return tap(e => {
    // Have to prevent default to avoid unexpected movement whe you grab object beneath scrollbar #476
    // https://github.com/MurhafSousli/ngx-scrollbar/issues/476
    e.preventDefault();
    e.stopPropagation();
  });
}
function getThrottledStream(stream, duration) {
  return stream.pipe(throttleTime(duration || 0, null, {
    leading: false,
    trailing: true
  }));
}
var ViewportClasses = /*#__PURE__*/function (ViewportClasses) {
  ViewportClasses["Viewport"] = "ng-scroll-viewport";
  ViewportClasses["Content"] = "ng-scroll-content";
  ViewportClasses["Spacer"] = "ng-scroll-spacer";
  return ViewportClasses;
}(ViewportClasses || {});
/**
 * Class representing a viewport adapter.
 * Provides methods and properties to interact with a viewport and its content.
 */
let ViewportAdapter = /*#__PURE__*/(() => {
  class ViewportAdapter {
    constructor() {
      /*
       * A signal that indicates when viewport adapter is initialized
       */
      this.initialized = signal(false);
    }
    /** Viewport clientHeight */
    get offsetHeight() {
      return this.nativeElement.offsetHeight;
    }
    /** Viewport clientWidth */
    get offsetWidth() {
      return this.nativeElement.offsetWidth;
    }
    /** Viewport scrollTop */
    get scrollTop() {
      return this.nativeElement.scrollTop;
    }
    /** Viewport scrollLeft */
    get scrollLeft() {
      return this.nativeElement.scrollLeft;
    }
    /** Content height */
    get contentHeight() {
      return this.contentWrapperElement.offsetHeight;
    }
    /** Content width */
    get contentWidth() {
      return this.contentWrapperElement.offsetWidth;
    }
    /** The remaining vertical scrollable distance. */
    get scrollMaxX() {
      return this.contentWidth - this.offsetWidth;
    }
    /** The vertical remaining scrollable distance */
    get scrollMaxY() {
      return this.contentHeight - this.offsetHeight;
    }
    /**
     * Initialize viewport
     */
    init(viewportElement, contentElement, spacerElement) {
      // Add viewport class
      viewportElement.classList.add(ViewportClasses.Viewport);
      this.nativeElement = viewportElement;
      // Add content wrapper class
      contentElement.classList.add(ViewportClasses.Content);
      // When integrating the scrollbar with virtual scroll, the content wrapper will have fake size,
      // and a spacer element will have the real size
      // Therefore, if spaceElement is provided, it will be observed instead of the content wrapper
      if (spacerElement) {
        spacerElement.classList.add(ViewportClasses.Spacer);
        this.contentWrapperElement = spacerElement;
      } else {
        // If spacer is not provided, set it as the content wrapper
        this.contentWrapperElement = contentElement;
      }
      this.initialized.set(true);
    }
    reset() {
      this.nativeElement = null;
      this.contentWrapperElement = null;
      this.initialized.set(false);
    }
    /**
     * Scrolls the viewport vertically to the specified value.
     */
    scrollYTo(value) {
      this.nativeElement.scrollTop = value;
    }
    /**
     * Scrolls the viewport horizontally to the specified value.
     */
    scrollXTo(value) {
      this.nativeElement.scrollLeft = value;
    }
    static {
      this.ɵfac = function ViewportAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ViewportAdapter)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ViewportAdapter,
        factory: ViewportAdapter.ɵfac
      });
    }
  }
  return ViewportAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Injection token that can be used to query for a `NgScrollbar`.
 * Used primarily to avoid circular imports.
 */
const NG_SCROLLBAR = new InjectionToken('NG_SCROLLBAR');
const defaultOptions = {
  trackClass: '',
  thumbClass: '',
  buttonClass: '',
  orientation: 'auto',
  appearance: 'native',
  visibility: 'native',
  position: 'native',
  trackScrollDuration: 50,
  sensorThrottleTime: 0,
  disableSensor: false,
  disableInteraction: false,
  buttons: false,
  hoverOffset: false
};
// This CDN link for a modified version of the polyfill to fix firefox bug https://github.com/MurhafSousli/ngx-scrollbar/issues/615
const defaultScrollTimelinePolyfill = 'https://cdn.statically.io/gist/MurhafSousli/c852b6a672069396953f06ddd4b64620/raw/ef55db72e2abb7bc002ed79f4ad4cf408bfdb72f/scroll-timeline-lite.js';
var ScrollbarUpdateReason = /*#__PURE__*/function (ScrollbarUpdateReason) {
  ScrollbarUpdateReason["AfterInit"] = "AfterInit";
  ScrollbarUpdateReason["Resized"] = "ResizeObserver";
  return ScrollbarUpdateReason;
}(ScrollbarUpdateReason || {});
const NG_SCROLLBAR_OPTIONS = new InjectionToken('NG_SCROLLBAR_OPTIONS', {
  providedIn: 'root',
  factory: () => defaultOptions
});
const NG_SCROLLBAR_POLYFILL = new InjectionToken('NG_SCROLLBAR_POLYFILL', {
  providedIn: 'root',
  factory: () => defaultScrollTimelinePolyfill
});
function filterResizeEntries(entries, target) {
  return entries.filter(entry => entry.target === target)[0]?.contentRect;
}
let NgScrollbarCore = /*#__PURE__*/(() => {
  class NgScrollbarCore {
    constructor() {
      /** Global options */
      this.options = inject(NG_SCROLLBAR_OPTIONS);
      this.sharedResizeObserver = inject(SharedResizeObserver);
      this.zone = inject(NgZone);
      this.platform = inject(Platform);
      /** A flag that indicates if the platform is mobile */
      this.isMobile = this.platform.IOS || this.platform.ANDROID;
      this.dir = inject(Directionality);
      this.smoothScroll = inject(SmoothScrollManager);
      /** Viewport adapter instance */
      this.viewport = inject(ViewportAdapter, {
        self: true
      });
      this.nativeElement = inject(ElementRef).nativeElement;
      /**
       * Indicates if the direction is 'ltr' or 'rtl'
       */
      this.direction = toSignal(this.dir.change, {
        initialValue: this.dir.value
      });
      /**
       * Indicates when scrollbar thumb is being dragged
       */
      this.dragging = signal('none');
      /**
       * Sets the supported scroll track of the viewport, there are 3 options:
       *
       * - `vertical` Use both vertical and horizontal scrollbar
       * - `horizontal` Use both vertical and horizontal scrollbar
       * - `auto` Use both vertical and horizontal scrollbar
       */
      this.orientation = input(this.options.orientation);
      /**
       * When to show the scrollbar, and there are 3 options:
       *
       * - `native` (default) Scrollbar will be visible when viewport is scrollable like with native scrollbar
       * - `hover` Scrollbars are hidden by default, only visible on scrolling or hovering
       * - `always` Scrollbars are always shown even if the viewport is not scrollable
       */
      this.visibility = input(this.options.visibility);
      /** Show scrollbar buttons */
      this.buttons = input(this.options.buttons, {
        transform: booleanAttribute
      });
      /** Disables scrollbar interaction like dragging thumb and jumping by track click */
      this.disableInteraction = input(this.options.disableInteraction, {
        transform: booleanAttribute
      });
      /** Whether ResizeObserver is disabled */
      this.disableSensor = input(this.options.disableSensor, {
        transform: booleanAttribute
      });
      /** Throttle interval for detecting changes via ResizeObserver */
      this.sensorThrottleTime = input(this.options.sensorThrottleTime, {
        transform: numberAttribute
      });
      /** A flag used to activate hover effect on the offset area around the scrollbar */
      this.hoverOffset = input(this.options.hoverOffset, {
        transform: booleanAttribute
      });
      /** Viewport dimension */
      this.viewportDimension = signal({
        width: 0,
        height: 0
      });
      /** Content dimension */
      this.contentDimension = signal({
        width: 0,
        height: 0
      });
      this.state = computed(() => {
        let verticalUsed = false;
        let horizontalUsed = false;
        let isVerticallyScrollable = false;
        let isHorizontallyScrollable = false;
        const orientation = this.orientation();
        const visibility = this.visibility();
        const viewportDimensions = this.viewportDimension();
        const contentDimensions = this.contentDimension();
        // Check if vertical scrollbar should be displayed
        if (orientation === 'auto' || orientation === 'vertical') {
          isVerticallyScrollable = contentDimensions.height > viewportDimensions.height;
          verticalUsed = visibility === 'visible' || isVerticallyScrollable;
        }
        // Check if horizontal scrollbar should be displayed
        if (orientation === 'auto' || orientation === 'horizontal') {
          isHorizontallyScrollable = contentDimensions.width > viewportDimensions.width;
          horizontalUsed = visibility === 'visible' || isHorizontallyScrollable;
        }
        return {
          verticalUsed,
          horizontalUsed,
          isVerticallyScrollable,
          isHorizontallyScrollable
        };
      });
      this.isVerticallyScrollable = computed(() => this.state().isVerticallyScrollable);
      this.isHorizontallyScrollable = computed(() => this.state().isHorizontallyScrollable);
      this.verticalUsed = computed(() => this.state().verticalUsed);
      this.horizontalUsed = computed(() => this.state().horizontalUsed);
      /** Scroll duration when the scroll track is clicked */
      this.trackScrollDuration = input(this.options.trackScrollDuration, {
        transform: numberAttribute
      });
      /**
       *  Sets the appearance of the scrollbar, there are 2 options:
       *
       * - `native` (default) scrollbar space will be reserved just like with native scrollbar.
       * - `compact` scrollbar doesn't reserve any space, they are placed over the viewport.
       */
      this.appearance = input(this.options.appearance);
      /**
       * Sets the position of each scrollbar, there are 4 options:
       *
       * - `native` (Default) Use the default position like in native scrollbar.
       * - `invertY` Inverts vertical scrollbar position
       * - `invertX` Inverts Horizontal scrollbar position
       * - `invertAll` Inverts both scrollbar positions
       */
      this.position = input(this.options.position);
      /** A class forwarded to the scrollbar track element */
      this.trackClass = input(this.options.trackClass);
      /** A class forwarded to the scrollbar thumb element */
      this.thumbClass = input(this.options.thumbClass);
      /** A class forwarded to the scrollbar button element */
      this.buttonClass = input(this.options.thumbClass);
      /** Steam that emits when scrollbar is initialized */
      this.afterInit = output();
      /** Steam that emits when scrollbar is updated */
      this.afterUpdate = output();
      let resizeSub$;
      let hasInitialized;
      afterRenderEffect({
        earlyRead: onCleanup => {
          const disableSensor = this.disableSensor();
          const throttleDuration = this.sensorThrottleTime();
          const viewportInit = this.viewport.initialized();
          untracked(() => {
            if (viewportInit) {
              // If resize sensor is disabled, update manually the first time
              if (disableSensor) {
                requestAnimationFrame(() => this.update(ScrollbarUpdateReason.AfterInit));
              } else {
                // Observe size changes for viewport and content wrapper
                this.zone.runOutsideAngular(() => {
                  resizeSub$ = getThrottledStream(combineLatest([this.sharedResizeObserver.observe(this.viewport.nativeElement), this.sharedResizeObserver.observe(this.viewport.contentWrapperElement)]), throttleDuration).subscribe(() => {
                    // After deep investigation, it appears that setting the dimension directly from the element properties
                    // is much faster than to set them from resize callback values
                    this.zone.run(() => {
                      this.updateDimensions();
                      if (hasInitialized) {
                        this.afterUpdate.emit();
                      } else {
                        this.afterInit.emit();
                      }
                      hasInitialized = true;
                    });
                  });
                });
              }
            }
            onCleanup(() => resizeSub$?.unsubscribe());
          });
        }
      });
    }
    /**
     * Manual update
     */
    update(reason) {
      this.updateDimensions();
      if (reason === ScrollbarUpdateReason.AfterInit) {
        this.afterInit.emit();
      } else {
        this.afterUpdate.emit();
      }
    }
    /**
     * Smooth scroll functions
     */
    scrollTo(options) {
      return this.smoothScroll.scrollTo(this.viewport.nativeElement, options);
    }
    /**
     * Scroll to element by reference or selector
     */
    scrollToElement(target, options) {
      return this.smoothScroll.scrollToElement(this.viewport.nativeElement, target, options);
    }
    updateDimensions() {
      this.viewportDimension.set({
        width: this.viewport.offsetWidth,
        height: this.viewport.offsetHeight
      });
      this.contentDimension.set({
        width: this.viewport.contentWidth,
        height: this.viewport.contentHeight
      });
    }
    static {
      this.ɵfac = function NgScrollbarCore_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgScrollbarCore)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgScrollbarCore,
        hostVars: 22,
        hostBindings: function NgScrollbarCore_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("verticalUsed", ctx.verticalUsed())("horizontalUsed", ctx.horizontalUsed())("isVerticallyScrollable", ctx.isVerticallyScrollable())("isHorizontallyScrollable", ctx.isHorizontallyScrollable())("mobile", ctx.isMobile)("dir", ctx.direction())("position", ctx.position())("dragging", ctx.dragging())("appearance", ctx.appearance())("visibility", ctx.visibility())("orientation", ctx.orientation())("disableInteraction", ctx.disableInteraction());
            i0.ɵɵstyleProp("--content-height", ctx.contentDimension().height)("--content-width", ctx.contentDimension().width)("--viewport-height", ctx.viewportDimension().height)("--viewport-width", ctx.viewportDimension().width);
            i0.ɵɵclassProp("ng-scrollbar", true);
          }
        },
        inputs: {
          orientation: [1, "orientation"],
          visibility: [1, "visibility"],
          buttons: [1, "buttons"],
          disableInteraction: [1, "disableInteraction"],
          disableSensor: [1, "disableSensor"],
          sensorThrottleTime: [1, "sensorThrottleTime"],
          hoverOffset: [1, "hoverOffset"],
          trackScrollDuration: [1, "trackScrollDuration"],
          appearance: [1, "appearance"],
          position: [1, "position"],
          trackClass: [1, "trackClass"],
          thumbClass: [1, "thumbClass"],
          buttonClass: [1, "buttonClass"]
        },
        outputs: {
          afterInit: "afterInit",
          afterUpdate: "afterUpdate"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_SCROLLBAR,
          useExisting: NgScrollbarCore
        }])]
      });
    }
  }
  return NgScrollbarCore;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SCROLLBAR_CONTROL = new InjectionToken('SCROLLBAR_CONTROL');
let ScrollbarAdapter = /*#__PURE__*/(() => {
  class ScrollbarAdapter {
    constructor() {
      this.trackSize = signal(0);
      // Host component reference
      this.cmp = inject(NG_SCROLLBAR);
    }
    static {
      this.ɵfac = function ScrollbarAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollbarAdapter)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ScrollbarAdapter
      });
    }
  }
  return ScrollbarAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PointerEventsAdapter = /*#__PURE__*/(() => {
  class PointerEventsAdapter {
    constructor() {
      // Reference to the NgScrollbar component
      this.cmp = inject(NG_SCROLLBAR);
      // Reference to the Scrollbar control component
      this.control = inject(SCROLLBAR_CONTROL);
      // Reference to the Document element
      this.document = inject(DOCUMENT);
      // Reference to angular zone
      this.zone = inject(NgZone);
      // The native element of the directive
      this.nativeElement = inject(ElementRef).nativeElement;
      effect(onCleanup => {
        const disableInteraction = this.cmp.disableInteraction();
        untracked(() => {
          if (!disableInteraction) {
            this.zone.runOutsideAngular(() => {
              this._pointerEventsSub = this.pointerEvents.subscribe();
            });
          }
          onCleanup(() => this._pointerEventsSub?.unsubscribe());
        });
      });
    }
    static {
      this.ɵfac = function PointerEventsAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PointerEventsAdapter)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: PointerEventsAdapter
      });
    }
  }
  return PointerEventsAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrackAdapter = /*#__PURE__*/(() => {
  class TrackAdapter extends PointerEventsAdapter {
    // Returns viewport client size
    get viewportSize() {
      return this.cmp.viewport[this.control.sizeProperty];
    }
    // Get track client rect
    get clientRect() {
      return this.nativeElement.getBoundingClientRect();
    }
    // Scrollbar track offset
    get offset() {
      return this.clientRect[this.control.rectOffsetProperty];
    }
    // Scrollbar track length
    get size() {
      // Noticed that clientHeight is evaluated before getClientRect.height,
      // causing a wrong track size when integrated in dropdown integration
      return this.nativeElement[this.control.sizeProperty];
    }
    // Observable for track dragging events
    get pointerEvents() {
      // Observable streams for pointer events
      const pointerDown$ = fromEvent(this.nativeElement, 'pointerdown').pipe(stopPropagation(), preventSelection(this.document));
      const pointerUp$ = fromEvent(this.document, 'pointerup', {
        passive: true
      }).pipe(enableSelection(this.document));
      const pointerEnter$ = fromEvent(this.nativeElement, 'pointerover', {
        passive: true
      }).pipe(
      // When mouse is out and enters again, must set the current position first
      tap(e => this.currMousePosition = e[this.control.offsetProperty]), map(() => true));
      const pointerLeave$ = fromEvent(this.nativeElement, 'pointerout', {
        passive: true
      }).pipe(map(() => false));
      const pointerOver$ = merge(pointerEnter$, pointerLeave$).pipe(startWith(true));
      // Keep track of current mouse location while dragging
      const pointerMove$ = fromEvent(this.nativeElement, 'pointermove', {
        passive: true
      }).pipe(tap(e => this.currMousePosition = e[this.control.offsetProperty]));
      return pointerDown$.pipe(switchMap(startEvent => {
        // Track pointer location while dragging
        pointerMove$.pipe(takeUntil(pointerUp$)).subscribe();
        return this.onTrackFirstClick(startEvent).pipe(delay(200), switchMap(() => {
          // Otherwise, activate pointermove and pointerout events and switch to ongoing scroll calls
          return pointerOver$.pipe(switchMap(over => {
            const currDirection = this.getScrollDirection(this.currMousePosition);
            const sameDirection = this.scrollDirection === currDirection;
            // If mouse is out the track pause the scroll calls, otherwise keep going
            return over && sameDirection ? this.onTrackOngoingMousedown() : EMPTY;
          }));
        }), takeUntil(pointerUp$));
      }));
    }
    constructor() {
      afterRenderEffect({
        earlyRead: () => {
          this.cmp.viewportDimension();
          this.cmp.contentDimension();
          untracked(() => {
            this.control.trackSize.set(this.size);
            if (!this.size) {
              // In some rare cases size could be 0 due to first render, use animation frame to give the track element time to render
              requestAnimationFrame(() => this.control.trackSize.set(this.size));
            }
          });
        }
      });
      super();
    }
    /**
     *  Callback when mouse is first clicked on the track
     */
    onTrackFirstClick(e) {
      // Initialize variables and determine scroll direction
      this.currMousePosition = e[this.control.offsetProperty];
      this.scrollDirection = this.getScrollDirection(this.currMousePosition);
      this.scrollMax = this.control.viewportScrollMax;
      return this.scrollTo(this.nextStep());
    }
    nextStep() {
      // Check which direction should the scroll go (forward or backward)
      if (this.scrollDirection === 'forward') {
        // Scroll forward
        const scrollForwardIncrement = this.getScrollForwardStep();
        // Check if the incremental position is bigger than the scroll max
        if (scrollForwardIncrement >= this.scrollMax) {
          return this.scrollMax;
        }
        return scrollForwardIncrement;
      }
      // Scroll backward
      const scrollBackwardIncrement = this.getScrollBackwardStep();
      if (scrollBackwardIncrement <= 0) {
        return 0;
      }
      return scrollBackwardIncrement;
    }
    /**
     * Callback when mouse is still down on the track
     * Incrementally scrolls towards target position until reached
     */
    onTrackOngoingMousedown() {
      const position = this.nextStep();
      return this.scrollTo(position).pipe(takeWhile(() => !this.isReached(position)), switchMap(() => this.onTrackOngoingMousedown()));
    }
    /**
     * Returns a flag that determines whether the scroll from the given position is the final step or not
     */
    isReached(position) {
      if (this.scrollDirection === 'forward') {
        return position >= this.scrollMax;
      }
      return position <= 0;
    }
    static {
      this.ɵfac = function TrackAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackAdapter)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TrackAdapter,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TrackAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrackXDirective = /*#__PURE__*/(() => {
  class TrackXDirective extends TrackAdapter {
    get contentSize() {
      return this.cmp.viewport.contentWidth;
    }
    constructor() {
      effect(() => {
        if (this.cmp.direction() === 'rtl') {
          this.getCurrPosition = () => {
            const offset = this.contentSize - this.viewportSize - this.control.viewportScrollOffset;
            return offset * this.size / this.contentSize;
          };
          this.getScrollDirection = position => {
            return position < this.getCurrPosition() ? 'forward' : 'backward';
          };
        } else {
          this.getCurrPosition = () => {
            return this.control.viewportScrollOffset * this.size / this.contentSize;
          };
          this.getScrollDirection = position => {
            return position > this.getCurrPosition() ? 'forward' : 'backward';
          };
        }
      });
      super();
    }
    scrollTo(start) {
      return from(this.cmp.scrollTo({
        start,
        duration: this.cmp.trackScrollDuration()
      }));
    }
    getScrollForwardStep() {
      return this.control.viewportScrollOffset + this.viewportSize;
    }
    getScrollBackwardStep() {
      return this.control.viewportScrollOffset - this.viewportSize;
    }
    static {
      this.ɵfac = function TrackXDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackXDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TrackXDirective,
        selectors: [["", "scrollbarTrackX", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: TrackAdapter,
          useExisting: TrackXDirective
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TrackXDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrackYDirective = /*#__PURE__*/(() => {
  class TrackYDirective extends TrackAdapter {
    get contentSize() {
      return this.cmp.viewport.contentHeight;
    }
    getCurrPosition() {
      return this.control.viewportScrollOffset * this.size / this.contentSize;
    }
    getScrollDirection(position) {
      return position > this.getCurrPosition() ? 'forward' : 'backward';
    }
    scrollTo(top) {
      return from(this.cmp.scrollTo({
        top,
        duration: this.cmp.trackScrollDuration()
      }));
    }
    getScrollForwardStep() {
      return this.control.viewportScrollOffset + this.viewportSize;
    }
    getScrollBackwardStep() {
      return this.control.viewportScrollOffset - this.viewportSize;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTrackYDirective_BaseFactory;
        return function TrackYDirective_Factory(__ngFactoryType__) {
          return (ɵTrackYDirective_BaseFactory || (ɵTrackYDirective_BaseFactory = i0.ɵɵgetInheritedFactory(TrackYDirective)))(__ngFactoryType__ || TrackYDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TrackYDirective,
        selectors: [["", "scrollbarTrackY", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: TrackAdapter,
          useExisting: TrackYDirective
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TrackYDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScrollbarManager = /*#__PURE__*/(() => {
  class ScrollbarManager {
    constructor() {
      this.isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
      this._polyfillUrl = inject(NG_SCROLLBAR_POLYFILL);
      this.document = inject(DOCUMENT);
      this.window = this.document.defaultView;
      this.scrollTimelinePolyfill = signal(null);
      if (this.isBrowser && (!this.window['ScrollTimeline'] || !CSS.supports('animation-timeline', 'scroll()'))) {
        this.initPolyfill();
      }
    }
    async initPolyfill() {
      try {
        // Create a script element
        const script = this.document.createElement('script');
        script.src = this._polyfillUrl;
        // Wait for the script to load
        await new Promise((resolve, reject) => {
          script.onload = resolve;
          script.onerror = reject;
          this.document.head.appendChild(script);
        });
        // Once loaded, access and execute the function attached to the window object
        if (this.window['ScrollTimeline']) {
          this.scrollTimelinePolyfill.set(this.window['ScrollTimeline']);
        } else {
          console.error('[NgScrollbar]: ScrollTimeline is not attached to the window object.');
        }
      } catch (error) {
        console.error('[NgScrollbar]: Error loading ScrollTimeline script:', error);
      }
    }
    static {
      this.ɵfac = function ScrollbarManager_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollbarManager)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ScrollbarManager,
        factory: ScrollbarManager.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScrollbarManager;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ThumbAdapter = /*#__PURE__*/(() => {
  class ThumbAdapter extends PointerEventsAdapter {
    // Returns thumb size
    get size() {
      return this.nativeElement.getBoundingClientRect()[this.control.rectSizeProperty];
    }
    // The maximum space available for scrolling.
    get trackMax() {
      return this.track.size - this.size;
    }
    /**
     * Stream that emits the 'scrollTo' position when a scrollbar thumb element is dragged
     * This function is called by thumb drag event using viewport or scrollbar pointer events
     */
    get pointerEvents() {
      return fromEvent(this.nativeElement, 'pointerdown').pipe(stopPropagation(), preventSelection(this.document), switchMap(e => {
        let startTrackMax;
        let startScrollMax;
        const dragStart = of(e).pipe(tap(() => {
          // Capture scrollMax and trackMax once
          startTrackMax = this.trackMax;
          startScrollMax = this.control.viewportScrollMax;
          this.setDragging(this.control.axis);
        }));
        const dragging = fromEvent(this.document, 'pointermove').pipe(stopPropagation());
        const dragEnd = fromEvent(this.document, 'pointerup', {
          capture: true
        }).pipe(stopPropagation(), enableSelection(this.document), tap(() => this.setDragging('none')));
        return dragStart.pipe(map(startEvent => startEvent[this.control.offsetProperty]), switchMap(startOffset => dragging.pipe(map(moveEvent => moveEvent[this.control.clientProperty]),
        // Calculate how far the pointer is from the top/left of the scrollbar (minus the dragOffset).
        map(moveClient => moveClient - this.track.offset), map(trackRelativeOffset => startScrollMax * (trackRelativeOffset - startOffset) / startTrackMax), tap(scrollPosition => this.control.instantScrollTo(scrollPosition, startScrollMax)), takeUntil(dragEnd))));
      }));
    }
    constructor() {
      afterRenderEffect({
        earlyRead: () => {
          const script = this.manager.scrollTimelinePolyfill();
          untracked(() => {
            if (script && !this._animation) {
              this._animation = startPolyfill(script, this.nativeElement, this.cmp.viewport.nativeElement, this.control.axis);
            }
          });
        }
      });
      super();
      this.manager = inject(ScrollbarManager);
      this.track = inject(TrackAdapter);
    }
    setDragging(value) {
      this.zone.run(() => this.cmp.dragging.set(value));
    }
    static {
      this.ɵfac = function ThumbAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ThumbAdapter)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ThumbAdapter,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ThumbAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function startPolyfill(ScrollTimeline, element, source, axis) {
  return element.animate({
    translate: ['var(--_scrollbar-thumb-transform-from)', 'var(--_scrollbar-thumb-transform-to)']
  }, {
    fill: 'both',
    easing: 'linear',
    timeline: new ScrollTimeline({
      source,
      axis
    })
  });
}
let ThumbXDirective = /*#__PURE__*/(() => {
  class ThumbXDirective extends ThumbAdapter {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵThumbXDirective_BaseFactory;
        return function ThumbXDirective_Factory(__ngFactoryType__) {
          return (ɵThumbXDirective_BaseFactory || (ɵThumbXDirective_BaseFactory = i0.ɵɵgetInheritedFactory(ThumbXDirective)))(__ngFactoryType__ || ThumbXDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ThumbXDirective,
        selectors: [["", "scrollbarThumbX", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: ThumbAdapter,
          useExisting: ThumbXDirective
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ThumbXDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ThumbYDirective = /*#__PURE__*/(() => {
  class ThumbYDirective extends ThumbAdapter {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵThumbYDirective_BaseFactory;
        return function ThumbYDirective_Factory(__ngFactoryType__) {
          return (ɵThumbYDirective_BaseFactory || (ɵThumbYDirective_BaseFactory = i0.ɵɵgetInheritedFactory(ThumbYDirective)))(__ngFactoryType__ || ThumbYDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ThumbYDirective,
        selectors: [["", "scrollbarThumbY", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: ThumbAdapter,
          useExisting: ThumbYDirective
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ThumbYDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// canScroll function can work for y-axis and x-axis for both LTR and RTL directions
const canScrollFunc = {
  forward: (scrollOffset, scrollMax) => scrollOffset < scrollMax,
  backward: scrollOffset => scrollOffset > 0
};
const scrollStepFunc = {
  forward: (scrollBy, offset) => offset + scrollBy,
  backward: (scrollBy, offset) => offset - scrollBy
};
const horizontalScrollStepFunc = {
  rtl: {
    forward: (scrollBy, offset, scrollMax) => scrollMax - offset - scrollBy,
    backward: (scrollBy, offset, scrollMax) => scrollMax - offset + scrollBy
  },
  ltr: scrollStepFunc
};
let ScrollbarButton = /*#__PURE__*/(() => {
  class ScrollbarButton extends PointerEventsAdapter {
    get pointerEvents() {
      const pointerDown$ = fromEvent(this.nativeElement, 'pointerdown').pipe(stopPropagation(), preventSelection(this.document));
      const pointerUp$ = fromEvent(this.document, 'pointerup', {
        passive: true
      }).pipe(enableSelection(this.document));
      const pointerLeave$ = fromEvent(this.nativeElement, 'pointerleave', {
        passive: true
      });
      // Combine pointerup and pointerleave events into one stream
      const pointerUpOrLeave$ = merge(pointerUp$, pointerLeave$);
      return pointerDown$.pipe(switchMap(() => this.firstScrollStep().pipe(delay(this.afterFirstClickDelay), switchMap(() => this.onOngoingPointerdown()), takeUntil(pointerUpOrLeave$))));
    }
    constructor() {
      effect(() => {
        const scrollDirection = this.scrollDirection();
        const dir = this.cmp.direction();
        untracked(() => {
          // Get the canScroll function according to scroll direction (forward/backward)
          this.canScroll = canScrollFunc[scrollDirection];
          if (this.control.axis === 'x') {
            // Get the nextStep function according to scroll direction (forward/backward) and layout direction (LTR/RTL)
            this.nextStep = horizontalScrollStepFunc[dir][scrollDirection];
          } else {
            // Get the nextStep function according to scroll direction (forward/backward)
            this.nextStep = scrollStepFunc[scrollDirection];
          }
        });
      });
      super();
      this.scrollbarButton = input.required();
      this.scrollDirection = input.required();
      this.afterFirstClickDelay = 120;
      this.firstClickDuration = 100;
      this.scrollBy = 50;
      this.onGoingScrollBy = 12;
    }
    firstScrollStep() {
      const value = this.nextStep(this.scrollBy, this.control.viewportScrollOffset, this.control.viewportScrollMax);
      return this.control.scrollTo(value, this.firstClickDuration);
    }
    onGoingScrollStep() {
      const scrollMax = this.control.viewportScrollMax;
      const value = this.nextStep(this.onGoingScrollBy, this.control.viewportScrollOffset, scrollMax);
      this.control.instantScrollTo(value, scrollMax);
    }
    onOngoingPointerdown() {
      return interval(0, animationFrameScheduler).pipe(takeWhile(() => this.canScroll(this.control.viewportScrollOffset, this.control.viewportScrollMax)), tap(() => this.onGoingScrollStep()));
    }
    static {
      this.ɵfac = function ScrollbarButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollbarButton)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ScrollbarButton,
        selectors: [["button", "scrollbarButton", ""]],
        inputs: {
          scrollbarButton: [1, "scrollbarButton"],
          scrollDirection: [1, "scrollDirection"]
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        attrs: _c0,
        decls: 3,
        vars: 0,
        consts: [[1, "ng-scrollbar-button-icon"], ["viewBox", "0 0 512 512", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M413.1,327.3l-1.8-2.1l-136-156.5c-4.6-5.3-11.5-8.6-19.2-8.6c-7.7,0-14.6,3.4-19.2,8.6L101,324.9l-2.3,2.6  C97,330,96,333,96,336.2c0,8.7,7.4,15.8,16.6,15.8v0h286.8v0c9.2,0,16.6-7.1,16.6-15.8C416,332.9,414.9,329.8,413.1,327.3z"]],
        template: function ScrollbarButton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdomElementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵdomElementStart(1, "svg", 1);
            i0.ɵɵdomElement(2, "path", 2);
            i0.ɵɵdomElementEnd()();
          }
        },
        styles: ["[_nghost-%COMP%]{position:relative;border:none;margin:0;padding:0;border-radius:0;appearance:none;background-color:var(--INTERNAL-scrollbar-button-color)}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{width:100%;height:100%;fill:var(--INTERNAL-scrollbar-button-fill)}[_nghost-%COMP%]:hover{background:var(--INTERNAL-scrollbar-button-hover-color)}[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]{fill:var(--INTERNAL-scrollbar-button-hover-fill)}[_nghost-%COMP%]:active{background:var(--INTERNAL-scrollbar-button-active-color)}[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]{fill:var(--INTERNAL-scrollbar-button-active-fill)}[scrollbarButton=top][_nghost-%COMP%], [scrollbarButton=start][_nghost-%COMP%]{order:1}[scrollbarButton=bottom][_nghost-%COMP%], [scrollbarButton=end][_nghost-%COMP%]{order:3}[scrollbarButton=top][_nghost-%COMP%], [scrollbarButton=bottom][_nghost-%COMP%]{width:100%;height:var(--INTERNAL-scrollbar-button-size)}[scrollbarButton=start][_nghost-%COMP%], [scrollbarButton=end][_nghost-%COMP%]{width:var(--INTERNAL-scrollbar-button-size);height:100%}[scrollbarButton=bottom][_nghost-%COMP%]{--_button-rotate: 180deg}[scrollbarButton=start][_nghost-%COMP%]{--_button-rotate: -90deg}[scrollbarButton=start][_nghost-%COMP%]   .ng-scrollbar-button-icon[_ngcontent-%COMP%]{writing-mode:vertical-lr}[scrollbarButton=end][_nghost-%COMP%]{--_button-rotate: 90deg}[scrollbarButton=end][_nghost-%COMP%]   .ng-scrollbar-button-icon[_ngcontent-%COMP%]{writing-mode:vertical-rl}.ng-scrollbar-button-icon[_ngcontent-%COMP%]{rotate:var(--_button-rotate);display:flex;place-content:center;place-items:center;width:100%;height:100%}"],
        changeDetection: 0
      });
    }
  }
  return ScrollbarButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScrollbarY = /*#__PURE__*/(() => {
  class ScrollbarY extends ScrollbarAdapter {
    constructor() {
      super(...arguments);
      this.rectOffsetProperty = 'top';
      this.rectSizeProperty = 'height';
      this.sizeProperty = 'offsetHeight';
      this.clientProperty = 'clientY';
      this.offsetProperty = 'offsetY';
      this.axis = 'y';
    }
    get viewportScrollMax() {
      return this.cmp.viewport.scrollMaxY;
    }
    get viewportScrollOffset() {
      return this.cmp.viewport.scrollTop;
    }
    scrollTo(top, duration) {
      return from(this.cmp.scrollTo({
        top,
        duration
      }));
    }
    instantScrollTo(value) {
      this.cmp.viewport.scrollYTo(value);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵScrollbarY_BaseFactory;
        return function ScrollbarY_Factory(__ngFactoryType__) {
          return (ɵScrollbarY_BaseFactory || (ɵScrollbarY_BaseFactory = i0.ɵɵgetInheritedFactory(ScrollbarY)))(__ngFactoryType__ || ScrollbarY);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ScrollbarY,
        selectors: [["scrollbar-y"]],
        hostVars: 2,
        hostBindings: function ScrollbarY_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("--track-size", ctx.trackSize());
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: SCROLLBAR_CONTROL,
          useExisting: ScrollbarY
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 11,
        consts: [[1, "ng-scrollbar-sticky"], [1, "ng-scrollbar-track-wrapper"], ["scrollbarTrackY", ""], ["scrollbarThumbY", ""], ["scrollbarButton", "top", "scrollDirection", "backward"], ["scrollbarButton", "bottom", "scrollDirection", "forward"]],
        template: function ScrollbarY_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(4, ScrollbarY_Conditional_4_Template, 2, 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("ng-scrollbar-hover", ctx.cmp.hoverOffset());
            i0.ɵɵadvance();
            i0.ɵɵclassProp("ng-scrollbar-hover", !ctx.cmp.hoverOffset());
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-track ", ctx.cmp.trackClass()));
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-thumb ", ctx.cmp.thumbClass()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.cmp.buttons() ? 4 : -1);
          }
        },
        dependencies: [TrackYDirective, ThumbYDirective, ScrollbarButton],
        styles: ["[_nghost-%COMP%]{position:absolute;inset:0;pointer-events:none;min-width:calc(var(--viewport-width) * 1px);min-height:calc(var(--viewport-height) * 1px)}.ng-scrollbar-sticky[_ngcontent-%COMP%]{top:calc(var(--_scrollbar-wrapper-top) * 1px);left:calc(var(--_scrollbar-wrapper-left) * 1px);right:calc(var(--_scrollbar-wrapper-right) * 1px);height:calc(var(--_scrollbar-wrapper-height) * 1px);width:calc(var(--_scrollbar-wrapper-width) * 1px);position:sticky;z-index:100;opacity:var(--_scrollbar-hover-opacity);transition:var(--_scrollbar-opacity-transition);pointer-events:var(--_scrollbar-pointer-events)}.ng-scrollbar-track-wrapper[_ngcontent-%COMP%]{touch-action:none;-webkit-user-select:none;user-select:none;top:var(--_scrollbar-track-top);bottom:var(--_scrollbar-track-bottom);right:var(--_scrollbar-track-right);left:var(--_scrollbar-track-left);transition:var(--INTERNAL-scrollbar-track-wrapper-transition);position:absolute;overflow:hidden;display:flex;place-items:center}.ng-scrollbar-track[_ngcontent-%COMP%]{position:relative;width:100%;height:100%;background-color:var(--INTERNAL-scrollbar-track-color);border-radius:var(--INTERNAL-scrollbar-border-radius);cursor:default;z-index:1;order:2}.ng-scrollbar-thumb[_ngcontent-%COMP%]{box-sizing:border-box;position:absolute;transition:var(--INTERNAL-scrollbar-thumb-transition);border-radius:var(--INTERNAL-scrollbar-border-radius);height:var(--_thumb-height);width:var(--_thumb-width);animation-name:_ngcontent-%COMP%_scrollbarThumbAnimation;animation-duration:1ms;animation-timing-function:linear}@keyframes _ngcontent-%COMP%_scrollbarThumbAnimation{0%{translate:var(--_scrollbar-thumb-transform-from)}to{translate:var(--_scrollbar-thumb-transform-to)}}", "[_nghost-%COMP%]{--_scrollbar-wrapper-top: 0;--_scrollbar-wrapper-left: var(--_scrollbar-wrapper-y-left);--_scrollbar-wrapper-right: var(--_scrollbar-wrapper-y-right);--_scrollbar-wrapper-height: var(--viewport-height);--_scrollbar-wrapper-width: var(--_scrollbar-thickness);--_scrollbar-track-top: var(--_vertical-top);--_scrollbar-track-bottom: var(--_vertical-bottom);--_scrollbar-track-right: var(--_vertical-right);--_scrollbar-track-left: var(--_vertical-left);--thumb-size: max(calc(var(--viewport-height) * var(--track-size) / var(--content-height)), var(--INTERNAL-scrollbar-thumb-min-size));--_thumb-height: calc(var(--thumb-size) * 1px);--_thumb-width: 100%;--_scrollbar-y-thumb-transform-to-value: calc(var(--track-size) - var(--thumb-size));--_scrollbar-thumb-transform-from: 0 0;--_scrollbar-thumb-transform-to: 0 calc(var(--_scrollbar-y-thumb-transform-to-value) * 1px)}.ng-scrollbar-track-wrapper[_ngcontent-%COMP%]{width:var(--_track-y-thickness);flex-direction:column}.ng-scrollbar-hover[_ngcontent-%COMP%]:hover, .ng-scrollbar-hover[_ngcontent-%COMP%]:active{--_track-y-thickness: var(--_scrollbar-hover-thickness-px);--_thumb-y-color: var(--INTERNAL-scrollbar-thumb-hover-color)}.ng-scrollbar-thumb[_ngcontent-%COMP%]{animation-timeline:var(--_animation-timeline-y);min-height:calc(var(--INTERNAL-scrollbar-thumb-min-size) * 1px);display:var(--_vertical-thumb-display);background-color:var(--_thumb-y-color)}"],
        changeDetection: 0
      });
    }
  }
  return ScrollbarY;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScrollbarX = /*#__PURE__*/(() => {
  class ScrollbarX extends ScrollbarAdapter {
    get viewportScrollMax() {
      return this.cmp.viewport.scrollMaxX;
    }
    get viewportScrollOffset() {
      // Keep scrollLeft value positive for horizontal scrollbar
      return Math.abs(this.cmp.viewport.scrollLeft);
    }
    constructor() {
      effect(() => {
        if (this.cmp.direction() === 'rtl') {
          this.handlePosition = (position, scrollMax) => -(scrollMax - position);
        } else {
          this.handlePosition = position => position;
        }
      });
      super();
      this.manager = inject(ScrollbarManager);
      this.rectOffsetProperty = 'left';
      this.rectSizeProperty = 'width';
      this.sizeProperty = 'offsetWidth';
      this.clientProperty = 'clientX';
      this.offsetProperty = 'offsetX';
      this.axis = 'x';
    }
    scrollTo(left, duration) {
      return from(this.cmp.scrollTo({
        left,
        duration
      }));
    }
    instantScrollTo(value, scrollMax) {
      this.cmp.viewport.scrollXTo(this.handlePosition(value, scrollMax));
    }
    static {
      this.ɵfac = function ScrollbarX_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollbarX)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ScrollbarX,
        selectors: [["scrollbar-x"]],
        hostVars: 3,
        hostBindings: function ScrollbarX_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("dir", ctx.cmp.direction());
            i0.ɵɵstyleProp("--track-size", ctx.trackSize());
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: SCROLLBAR_CONTROL,
          useExisting: ScrollbarX
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 11,
        consts: [[1, "ng-scrollbar-sticky"], [1, "ng-scrollbar-track-wrapper"], ["scrollbarTrackX", ""], ["scrollbarThumbX", ""], ["scrollbarButton", "start", "scrollDirection", "backward"], ["scrollbarButton", "end", "scrollDirection", "forward"]],
        template: function ScrollbarX_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(4, ScrollbarX_Conditional_4_Template, 2, 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("ng-scrollbar-hover", ctx.cmp.hoverOffset());
            i0.ɵɵadvance();
            i0.ɵɵclassProp("ng-scrollbar-hover", !ctx.cmp.hoverOffset());
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-track ", ctx.cmp.trackClass()));
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵinterpolate1("ng-scrollbar-thumb ", ctx.cmp.thumbClass()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.cmp.buttons() ? 4 : -1);
          }
        },
        dependencies: [TrackXDirective, ThumbXDirective, ScrollbarButton],
        styles: [_c1, "[_nghost-%COMP%]{--_scrollbar-wrapper-top: var(--_scrollbar-wrapper-x-top);--_scrollbar-wrapper-left: 0;--_scrollbar-wrapper-right: 0;--_scrollbar-wrapper-height: var(--_scrollbar-thickness);--_scrollbar-wrapper-width: var(--viewport-width);--_scrollbar-track-top: var(--_horizontal-top);--_scrollbar-track-bottom: var(--_horizontal-bottom);--_scrollbar-track-right: var(--_horizontal-right);--_scrollbar-track-left: var(--_horizontal-left);--thumb-size: max(calc(var(--viewport-width) * var(--track-size) / var(--content-width)), var(--INTERNAL-scrollbar-thumb-min-size));--_thumb-height: 100%;--_thumb-width: calc(var(--thumb-size) * 1px);--_scrollbar-x-thumb-transform-to-value: calc(var(--track-size) - var(--thumb-size));--_scrollbar-thumb-transform-from: 0;--_scrollbar-thumb-transform-to: calc(var(--_scrollbar-x-thumb-transform-to-value) * 1px)}[_nghost-%COMP%]   .ng-scrollbar-button[scrollbarButton=start][_ngcontent-%COMP%]{_--button-rotate:90}[_nghost-%COMP%]   .ng-scrollbar-button[scrollbarButton=end][_ngcontent-%COMP%]{_--button-rotate:-90}[dir=rtl][_nghost-%COMP%]   .ng-scrollbar-thumb[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_scrollbarThumbRTLAnimation;will-change:right;--_scrollbar-thumb-transform-to: calc(var(--_scrollbar-x-thumb-transform-to-value) * -1px)}[dir=rtl][_nghost-%COMP%]   .ng-scrollbar-button[scrollbarButton=start][_ngcontent-%COMP%]{--_button-rotate: 90deg}[dir=rtl][_nghost-%COMP%]   .ng-scrollbar-button[scrollbarButton=end][_ngcontent-%COMP%]{--_button-rotate: -90deg}.ng-scrollbar-track-wrapper[_ngcontent-%COMP%]{height:var(--_track-x-thickness);flex-direction:row}.ng-scrollbar-hover[_ngcontent-%COMP%]:hover, .ng-scrollbar-hover[_ngcontent-%COMP%]:active{--_track-x-thickness: var(--_scrollbar-hover-thickness-px);--_thumb-x-color: var(--INTERNAL-scrollbar-thumb-hover-color)}.ng-scrollbar-thumb[_ngcontent-%COMP%]{animation-timeline:var(--_animation-timeline-x);min-width:calc(var(--INTERNAL-scrollbar-thumb-min-size) * 1px);display:var(--_horizontal-thumb-display);background-color:var(--_thumb-x-color)}@keyframes _ngcontent-%COMP%_scrollbarThumbRTLAnimation{0%{right:var(--_scrollbar-thumb-transform-from)}to{right:calc(var(--_scrollbar-thumb-transform-to) * -1)}}"],
        changeDetection: 0
      });
    }
  }
  return ScrollbarX;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Scrollbars = /*#__PURE__*/(() => {
  class Scrollbars {
    constructor() {
      this.cmp = inject(NG_SCROLLBAR);
    }
    static {
      this.ɵfac = function Scrollbars_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Scrollbars)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Scrollbars,
        selectors: [["scrollbars"]],
        decls: 2,
        vars: 2,
        template: function Scrollbars_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, Scrollbars_Conditional_0_Template, 1, 0, "scrollbar-y");
            i0.ɵɵconditionalCreate(1, Scrollbars_Conditional_1_Template, 1, 0, "scrollbar-x");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.cmp.verticalUsed() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.cmp.horizontalUsed() ? 1 : -1);
          }
        },
        dependencies: [ScrollbarX, ScrollbarY],
        styles: ["[_nghost-%COMP%]{display:contents}"],
        changeDetection: 0
      });
    }
  }
  return Scrollbars;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgScrollbar = /*#__PURE__*/(() => {
  class NgScrollbar extends NgScrollbarCore {
    constructor() {
      effect(() => {
        const contentWrapper = this.contentWrapper().nativeElement;
        untracked(() => {
          this.viewport.init(this.nativeElement, contentWrapper);
        });
      });
      super();
      this.contentWrapper = viewChild.required('contentWrapper');
      this._scrollbars = viewChild.required(Scrollbars);
    }
    static {
      this.ɵfac = function NgScrollbar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgScrollbar)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgScrollbar,
        selectors: [["ng-scrollbar", 3, "externalViewport", ""]],
        viewQuery: function NgScrollbar_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.contentWrapper, _c2, 5);
            i0.ɵɵviewQuerySignal(ctx._scrollbars, Scrollbars, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        exportAs: ["ngScrollbar"],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_SCROLLBAR,
          useExisting: NgScrollbar
        }, ViewportAdapter]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c3,
        decls: 4,
        vars: 0,
        consts: [["contentWrapper", ""]],
        template: function NgScrollbar_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelement(3, "scrollbars");
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [Scrollbars],
        styles: ["[_nghost-%COMP%]{display:block;position:relative;max-height:100%;max-width:100%;--INTERNAL-scrollbar-border-radius: var(--scrollbar-border-radius, 0px);--INTERNAL-scrollbar-thickness: var(--scrollbar-thickness, 5);--INTERNAL-scrollbar-offset: var(--scrollbar-offset, 0);--INTERNAL-scrollbar-track-wrapper-transition: var(--scrollbar-track-wrapper-transition, width 60ms linear, height 60ms linear);--INTERNAL-scrollbar-track-color: var(--scrollbar-track-color, transparent);--INTERNAL-scrollbar-thumb-color: var(--scrollbar-thumb-color, rgb(0 0 0 / 20%));--INTERNAL-scrollbar-thumb-hover-color: var(--scrollbar-thumb-hover-color, var(--INTERNAL-scrollbar-thumb-color));--INTERNAL-scrollbar-hover-thickness: var(--scrollbar-hover-thickness, var(--INTERNAL-scrollbar-thickness));--INTERNAL-scrollbar-thumb-transition: var(--scrollbar-thumb-transition, none);--INTERNAL-scrollbar-thumb-min-size: var(--scrollbar-thumb-min-size, 20);--INTERNAL-scrollbar-button-color: var(--scrollbar-button-color, var(--INTERNAL-scrollbar-thumb-color));--INTERNAL-scrollbar-button-hover-color: var(--scrollbar-button-hover-color, var(--INTERNAL-scrollbar-button-color));--INTERNAL-scrollbar-button-active-color: var(--scrollbar-button-active-color, var(--INTERNAL-scrollbar-button-hover-color));--INTERNAL-scrollbar-button-fill: var(--scrollbar-button-fill, white);--INTERNAL-scrollbar-button-hover-fill: var(--scrollbar-button-hover-fill, var(--INTERNAL-scrollbar-button-fill));--INTERNAL-scrollbar-button-active-fill: var(--scrollbar-button-active-fill, var(--INTERNAL-scrollbar-button-hover-fill));--INTERNAL-scrollbar-button-size: var(--scrollbar-button-size, 20px);--INTERNAL-scrollbar-hover-opacity-transition-enter-duration: var(--scrollbar-hover-opacity-transition-enter-duration, 0);--INTERNAL-scrollbar-hover-opacity-transition-leave-duration: var(--scrollbar-hover-opacity-transition-leave-duration, .4s);--INTERNAL-scrollbar-hover-opacity-transition-leave-delay: var(--scrollbar-hover-opacity-transition-leave-delay, 1s);--INTERNAL-scrollbar-overscroll-behavior: var(--scrollbar-overscroll-behavior, initial);--INTERNAL-scrollbar-mobile-overscroll-behavior: var(--scrollbar-mobile-overscroll-behavior, none);--_scrollbar-thickness: calc(var(--INTERNAL-scrollbar-thickness) + var(--INTERNAL-scrollbar-offset) * 2);--_scrollbar-pointer-events: auto;--_scrollbar-offset-px: calc(var(--INTERNAL-scrollbar-offset) * 1px);--_scrollbar-thickness-px: calc(var(--INTERNAL-scrollbar-thickness) * 1px);--_scrollbar-hover-thickness-px: calc(var(--INTERNAL-scrollbar-hover-thickness) * 1px);--_viewport-padding-top: 0;--_viewport-padding-bottom: 0;--_viewport-padding-left: 0;--_viewport-padding-right: 0;--_horizontal-thumb-display: block;--_vertical-thumb-display: block;--_viewport-overflow: auto;--_viewport-pointer-events: auto;--_thumb-x-color: var(--INTERNAL-scrollbar-thumb-color);--_thumb-y-color: var(--INTERNAL-scrollbar-thumb-color);--_track-y-thickness: var(--_scrollbar-thickness-px);--_track-x-thickness: var(--_scrollbar-thickness-px);--_viewport-overscroll-behavior: var(--INTERNAL-scrollbar-overscroll-behavior);--_scrollbar-content-width: fit-content}[_nghost-%COMP%]{--_spacer-width: var(--spacer-width);--_spacer-height: var(--spacer-height);--_vertical-top: var(--_scrollbar-offset-px);--_vertical-bottom: var(--_scrollbar-offset-px);--_horizontal-left: var(--_scrollbar-offset-px);--_horizontal-right: var(--_scrollbar-offset-px);--_horizontal-top: initial;--_horizontal-bottom: var(--_scrollbar-offset-px);--_scrollbar-wrapper-x-top: calc(var(--viewport-height) - var(--_scrollbar-thickness));--reached-offset: 1px;--reached-offset-top: var(--reached-offset);--reached-offset-bottom: var(--reached-offset);--reached-offset-start: var(--reached-offset);--reached-offset-end: var(--reached-offset);--dropped-offset: 1px;--dropped-offset-top: var(--dropped-offset);--dropped-offset-bottom: var(--dropped-offset);--dropped-offset-start: var(--dropped-offset);--dropped-offset-end: var(--dropped-offset);--_viewport_scroll-timeline: unset;--_animation-timeline-y: unset;--_scrollbar-y-thumb-transform-to-value: unset;--_scrollbar-x-thumb-transform-to-value: unset;--_scrollbar-thumb-transform-from: unset;--_scrollbar-thumb-transform-to: unset}.ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport{min-height:100%;min-width:100%;height:100%;max-height:100%;max-width:100%}.ng-scroll-viewport[_nghost-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport{position:relative;overflow:var(--_viewport-overflow);scroll-timeline:var(--_viewport_scroll-timeline);box-sizing:border-box!important;-webkit-overflow-scrolling:touch;will-change:scroll-position;-webkit-user-select:var(--_viewport-user-select);user-select:var(--_viewport-user-select);overscroll-behavior:var(--_viewport-overscroll-behavior);pointer-events:var(--_viewport-pointer-events)}.ng-scroll-viewport[_nghost-%COMP%] > .ng-scroll-content[_ngcontent-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport>.ng-scroll-content{width:var(--_scrollbar-content-width);z-index:1;min-width:100%;min-height:100%;contain:content;padding:var(--_viewport-padding-top, 0) var(--_viewport-padding-right, 0) var(--_viewport-padding-bottom, 0) var(--_viewport-padding-left, 0)}[appearance=native][_nghost-%COMP%]{--_spacer-width: calc(var(--spacer-width) + var(--_scrollbar-thickness));--_spacer-height: calc(var(--spacer-height) + var(--_scrollbar-thickness))}.ng-scroll-viewport[_nghost-%COMP%] > .ng-scroll-spacer[_ngcontent-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport>.ng-scroll-spacer{position:relative;width:calc(var(--_spacer-width) * 1px);height:calc(var(--_spacer-height) * 1px)}.ng-scroll-viewport[_nghost-%COMP%], .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport{scrollbar-width:none!important}.ng-scroll-viewport[_nghost-%COMP%]::-webkit-scrollbar, .ng-scrollbar-external-viewport[_nghost-%COMP%]     .ng-scroll-viewport::-webkit-scrollbar{display:none!important}[position=invertX][_nghost-%COMP%], [position=invertAll][_nghost-%COMP%]{--_horizontal-top: var(--_scrollbar-offset-px);--_horizontal-bottom: initial;--_scrollbar-wrapper-x-top: 0}[dir=ltr][_nghost-%COMP%]{--_scrollbar-wrapper-y-right: initial;--_vertical-right: var(--_scrollbar-offset-px);--_vertical-left: initial;--_scrollbar-wrapper-y-left: calc(var(--viewport-width) - var(--_scrollbar-thickness))}[dir=ltr][position=invertY][_nghost-%COMP%], [dir=ltr][position=invertAll][_nghost-%COMP%]{--_vertical-left: var(--_scrollbar-offset-px);--_vertical-right: initial;--_scrollbar-wrapper-y-left: 0}[dir=rtl][_nghost-%COMP%]{--_scrollbar-wrapper-y-left: initial;--_vertical-left: var(--_scrollbar-offset-px);--_vertical-right: initial;--_scrollbar-wrapper-y-right: calc(var(--viewport-width) - var(--_scrollbar-thickness))}[dir=rtl][position=invertY][_nghost-%COMP%], [dir=rtl][position=invertAll][_nghost-%COMP%]{--_vertical-right: var(--_scrollbar-offset-px);--_vertical-left: initial;--_scrollbar-wrapper-y-right: 0}[verticalUsed=true][horizontalUsed=true][_nghost-%COMP%]{--_scrollbar-thickness-margin: calc(var(--INTERNAL-scrollbar-thickness) + var(--INTERNAL-scrollbar-offset) * 3);--_scrollbar-thickness-margin-px: calc(var(--_scrollbar-thickness-margin) * 1px)}[horizontalUsed=true][_nghost-%COMP%]{--_vertical-top: var(--_scrollbar-offset-px);--_vertical-bottom: var(--_scrollbar-thickness-margin-px)}[horizontalUsed=true][position=invertX][_nghost-%COMP%], [horizontalUsed=true][position=invertAll][_nghost-%COMP%]{--_vertical-top: var(--_scrollbar-thickness-margin-px);--_vertical-bottom: var(--_scrollbar-offset-px)}[verticalUsed=true][dir=ltr][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-offset-px);--_horizontal-right: var(--_scrollbar-thickness-margin-px)}[verticalUsed=true][dir=rtl][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-thickness-margin-px);--_horizontal-right: var(--_scrollbar-offset-px)}[verticalUsed=true][position=invertY][dir=ltr][_nghost-%COMP%], [verticalUsed=true][position=invertAll][dir=ltr][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-thickness-margin-px);--_horizontal-right: var(--_scrollbar-offset-px)}[verticalUsed=true][position=invertY][dir=rtl][_nghost-%COMP%], [verticalUsed=true][position=invertAll][dir=rtl][_nghost-%COMP%]{--_horizontal-left: var(--_scrollbar-offset-px);--_horizontal-right: var(--_scrollbar-thickness-margin-px)}[appearance=native][verticalUsed=true][dir=ltr][_nghost-%COMP%]{--_viewport-padding-left: 0;--_viewport-padding-right: calc(var(--_scrollbar-thickness) * 1px)}[appearance=native][verticalUsed=true][dir=rtl][_nghost-%COMP%]{--_viewport-padding-left: calc(var(--_scrollbar-thickness) * 1px);--_viewport-padding-right: 0}[appearance=native][verticalUsed=true][position=invertY][dir=ltr][_nghost-%COMP%], [appearance=native][verticalUsed=true][position=invertAll][dir=ltr][_nghost-%COMP%]{--_viewport-padding-left: calc(var(--_scrollbar-thickness) * 1px);--_viewport-padding-right: 0}[appearance=native][verticalUsed=true][position=invertY][dir=rtl][_nghost-%COMP%], [appearance=native][verticalUsed=true][position=invertAll][dir=rtl][_nghost-%COMP%]{--_viewport-padding-left: 0;--_viewport-padding-right: calc(var(--_scrollbar-thickness) * 1px)}[appearance=native][horizontalUsed=true][_nghost-%COMP%]{--_viewport-padding-top: 0;--_viewport-padding-bottom: calc(var(--_scrollbar-thickness) * 1px)}[appearance=native][horizontalUsed=true][position=invertX][_nghost-%COMP%], [appearance=native][horizontalUsed=true][position=invertAll][_nghost-%COMP%]{--_viewport-padding-top: calc(var(--_scrollbar-thickness) * 1px);--_viewport-padding-bottom: 0}[visibility=hover][_nghost-%COMP%]{--_scrollbar-hover-opacity: 0;--_scrollbar-opacity-transition: opacity var(--INTERNAL-scrollbar-hover-opacity-transition-leave-duration) var(--INTERNAL-scrollbar-hover-opacity-transition-leave-delay)}[visibility=hover][_nghost-%COMP%]:hover, [visibility=hover][_nghost-%COMP%]:active, [visibility=hover][_nghost-%COMP%]:focus{--_scrollbar-hover-opacity: 1;--_scrollbar-opacity-transition: opacity var(--INTERNAL-scrollbar-hover-opacity-transition-enter-duration)}[dir=ltr][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start], [dir=ltr][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=start]{left:0;right:unset}[dir=ltr][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end], [dir=ltr][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=end]{right:0;left:unset}[dir=rtl][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start], [dir=rtl][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=start]{right:0;left:unset}[dir=rtl][_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end], [dir=rtl][_nghost-%COMP%]     .scroll-dropped-trigger-element[trigger=end]{left:0;right:unset}[_nghost-%COMP%]     .ng-scroll-reached-wrapper, [_nghost-%COMP%]     .ng-scroll-dropped-wrapper, [_nghost-%COMP%]     .scroll-reached-trigger-element, [_nghost-%COMP%]     .scroll-dropped-trigger-element{position:absolute;-webkit-user-select:none;user-select:none;pointer-events:none;z-index:-9999}[_nghost-%COMP%]     .ng-scroll-reached-wrapper, [_nghost-%COMP%]     .ng-scroll-dropped-wrapper{visibility:hidden;inset:0;min-width:calc(var(--viewport-width) * 1px);min-height:calc(var(--viewport-height) * 1px)}[_nghost-%COMP%]     [isHorizontallyScrollable=false] .scroll-reached-trigger-element[trigger=end], [_nghost-%COMP%]     [isHorizontallyScrollable=false] .scroll-dropped-trigger-element[trigger=end]{display:none}[_nghost-%COMP%]     [isVerticallyScrollable=false] .scroll-reached-trigger-element[trigger=bottom], [_nghost-%COMP%]     [isVerticallyScrollable=false] .scroll-dropped-trigger-element[trigger=bottom]{display:none}[_nghost-%COMP%]     .scroll-reached-trigger-element{background:red}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=top], [_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=bottom]{left:0;right:0}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start], [_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end]{top:0;bottom:0}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=top]{top:0;height:var(--reached-offset-top)}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=bottom]{bottom:0;height:var(--reached-offset-bottom)}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=start]{width:var(--reached-offset-start)}[_nghost-%COMP%]     .scroll-reached-trigger-element[trigger=end]{width:var(--reached-offset-end)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[_ngcontent-%COMP%]{background:#00f}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=top][_ngcontent-%COMP%], [_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=bottom][_ngcontent-%COMP%]{left:0;right:0}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=start][_ngcontent-%COMP%], [_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=end][_ngcontent-%COMP%]{top:0;bottom:0}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=top][_ngcontent-%COMP%]{top:0;height:var(--dropped-offset-top)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=bottom][_ngcontent-%COMP%]{bottom:0;height:var(--dropped-offset-bottom)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=start][_ngcontent-%COMP%]{width:var(--dropped-offset-start)}[_nghost-%COMP%]   .scroll-dropped-trigger-element[trigger=end][_ngcontent-%COMP%]{width:var(--dropped-offset-end)}[verticalUsed=true][_nghost-%COMP%]{--_timeline-scope: --scrollerY;--_animation-timeline-y: --scrollerY;--_viewport_scroll-timeline: --scrollerY y}[horizontalUsed=true][_nghost-%COMP%]{--_timeline-scope: --scrollerX;--_animation-timeline-x: --scrollerX;--_viewport_scroll-timeline: --scrollerX x}[verticalUsed=true][horizontalUsed=true][_nghost-%COMP%]{--_timeline-scope: --scrollerX, --scrollerY;--_viewport_scroll-timeline: --scrollerX x, --scrollerY y}[orientation=vertical][_nghost-%COMP%]{--_viewport-overflow: hidden auto;--_scrollbar-content-width: unset}[orientation=horizontal][_nghost-%COMP%]{--_viewport-overflow: auto hidden}[disableInteraction=true][_nghost-%COMP%]{--_viewport-pointer-events: none;--_scrollbar-pointer-events: none}[isVerticallyScrollable=false][_nghost-%COMP%]{--_vertical-thumb-display: none}[isHorizontallyScrollable=false][_nghost-%COMP%]{--_horizontal-thumb-display: none}[dragging=x][_nghost-%COMP%], [dragging=y][_nghost-%COMP%]{--_viewport-user-select: none}[dragging=x][_nghost-%COMP%]{--_track-x-thickness: calc(var(--INTERNAL-scrollbar-hover-thickness) * 1px);--_thumb-x-color: var(var(--INTERNAL-scrollbar-thumb-min-size))}[dragging=y][_nghost-%COMP%]{--_track-y-thickness: calc(var(--INTERNAL-scrollbar-hover-thickness) * 1px);--_thumb-y-color: var(var(--INTERNAL-scrollbar-thumb-min-size))}[mobile=true][_nghost-%COMP%]{--_viewport-overscroll-behavior: var(--INTERNAL-scrollbar-mobile-overscroll-behavior)}"],
        changeDetection: 0
      });
    }
  }
  return NgScrollbar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgScrollbarExt = /*#__PURE__*/(() => {
  class NgScrollbarExt extends NgScrollbarCore {
    constructor() {
      // Using `afterRenderEffect` would run twice, one when viewport directive is detected
      // and one when content wrapper is detected, therefore `effect` is better because it runs only once.
      effect(() => {
        const viewportElement = this.viewportElement();
        const contentWrapperElement = this.contentWrapperElement();
        const spacerElement = this.spacerElement();
        const viewportError = this.viewportError();
        const contentWrapperError = this.contentWrapperError();
        const spacerError = this.spacerError();
        untracked(() => {
          if (!this.skipInit) {
            const error = viewportError || contentWrapperError || spacerError;
            if (error) {
              console.error(error);
            } else {
              this.initialize(viewportElement, contentWrapperElement, spacerElement);
            }
          }
        });
      });
      super();
      this.renderer = inject(Renderer2);
      this.appRef = inject(ApplicationRef);
      this._scrollbars = signal(null);
      /**
       * Selector used to query the viewport element.
       */
      this.externalViewport = input();
      /**
       * Selector used to query the content wrapper element.
       */
      this.externalContentWrapper = input();
      /**
       * Selector used to query the spacer element (virtual scroll integration).
       * In the case of integrating the scrollbar with a virtual scroll component,
       * a spacer element is typically created to match the real size of the content.
       * The scrollbar will use the size of this spacer element for calculations instead of the content wrapper size.
       */
      this.externalSpacer = input();
      this.viewportElement = linkedSignal({
        source: this.externalViewport,
        // If viewport selector was defined, query the element
        computation: selector => this.getElement(selector) || this.customViewport()?.nativeElement
      });
      this.viewportError = computed(() => {
        return !this.viewportElement() ? `[NgScrollbar]: Could not find the viewport element for the provided selector "${this.externalViewport()}"` : null;
      });
      this.contentWrapperElement = linkedSignal({
        source: this.externalContentWrapper,
        computation: selector => this.getElement(selector)
      });
      this.contentWrapperError = computed(() => {
        return !this.contentWrapperElement() && this.externalContentWrapper() ? `[NgScrollbar]: Content wrapper element not found for the provided selector "${this.externalContentWrapper()}"` : null;
      });
      this.spacerElement = linkedSignal({
        source: this.externalSpacer,
        computation: selector => this.getElement(selector)
      });
      this.spacerError = computed(() => {
        return !this.spacerElement() && this.externalSpacer() ? `[NgScrollbar]: Spacer element not found for the provided selector "${this.externalSpacer()}"` : null;
      });
      /**
       * Reference to the external viewport directive if used
       */
      this.customViewport = contentChild(ScrollViewport, {
        descendants: true
      });
    }
    ngOnDestroy() {
      if (this._scrollbarsRef) {
        this.appRef.detachView(this._scrollbarsRef.hostView);
        this._scrollbarsRef.destroy();
      }
    }
    initialize(viewportElement, contentWrapperElement, spacerElement) {
      if (this.skipInit) {
        // If initialized via async detection, then we should set the signals
        this.viewportElement.set(viewportElement);
        this.contentWrapperElement.set(contentWrapperElement);
        this.spacerElement.set(spacerElement);
      }
      // If no external spacer and no content wrapper are provided, create a content wrapper element
      if (!spacerElement && !contentWrapperElement) {
        contentWrapperElement = this.renderer.createElement('div');
        // Move all content of the viewport into the content wrapper
        const childNodes = Array.from(viewportElement.childNodes);
        childNodes.forEach(node => this.renderer.appendChild(contentWrapperElement, node));
        // Append the content wrapper to the viewport
        this.renderer.appendChild(viewportElement, contentWrapperElement);
      }
      // Make sure content wrapper element is defined to proceed
      if (contentWrapperElement) {
        // Initialize viewport
        this.viewport.init(viewportElement, contentWrapperElement, spacerElement);
        // Attach scrollbars
        this._attachScrollbars();
      }
    }
    _attachScrollbars() {
      // Create the scrollbars component
      this._scrollbarsRef = createComponent(Scrollbars, {
        environmentInjector: this.appRef.injector,
        elementInjector: Injector.create({
          providers: [{
            provide: NG_SCROLLBAR,
            useValue: this
          }]
        })
      });
      // Attach scrollbar to the content wrapper
      this.renderer.appendChild(this.viewport.contentWrapperElement, this._scrollbarsRef.location.nativeElement);
      // Attach the host view of the component to the main change detection tree, so that its lifecycle hooks run.
      this.appRef.attachView(this._scrollbarsRef.hostView);
      // Set the scrollbars instance
      this._scrollbars.set(this._scrollbarsRef.instance);
    }
    getElement(selector) {
      return selector ? this.nativeElement.querySelector(selector) : null;
    }
    static {
      this.ɵfac = function NgScrollbarExt_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgScrollbarExt)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgScrollbarExt,
        selectors: [["ng-scrollbar", "externalViewport", ""]],
        contentQueries: function NgScrollbarExt_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.customViewport, ScrollViewport, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostAttrs: ["ngSkipHydration", "true"],
        hostVars: 2,
        hostBindings: function NgScrollbarExt_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ng-scrollbar-external-viewport", true);
          }
        },
        inputs: {
          externalViewport: [1, "externalViewport"],
          externalContentWrapper: [1, "externalContentWrapper"],
          externalSpacer: [1, "externalSpacer"]
        },
        exportAs: ["ngScrollbar"],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_SCROLLBAR,
          useExisting: NgScrollbarExt
        }, {
          provide: NgScrollbarCore,
          useExisting: NgScrollbar
        }, ViewportAdapter]), i0.ɵɵInheritDefinitionFeature],
        attrs: _c4,
        ngContentSelectors: _c3,
        decls: 1,
        vars: 0,
        template: function NgScrollbarExt_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: [_c5],
        changeDetection: 0
      });
    }
  }
  return NgScrollbarExt;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AsyncDetection = /*#__PURE__*/(() => {
  class AsyncDetection {
    constructor() {
      this.scrollbar = inject(NgScrollbarExt, {
        self: true
      });
      this.zone = inject(NgZone);
      this.contentObserver = inject(ContentObserver);
      this.asyncDetection = input();
      this.scrollbar.skipInit = true;
      let sub$;
      effect(onCleanup => {
        const init = this.scrollbar.viewport.initialized();
        const externalViewport = this.scrollbar.externalViewport();
        const externalContentWrapper = this.scrollbar.externalContentWrapper();
        const externalSpacer = this.scrollbar.externalSpacer();
        const asyncDetection = this.asyncDetection();
        untracked(() => {
          let viewportElement;
          let contentWrapperElement;
          this.zone.runOutsideAngular(() => {
            // The content observer should not be throttled using the same function we use for ResizeObserver,
            // It should detect the content change asap to attach the scrollbar
            sub$ = this.contentObserver.observe(this.scrollbar.nativeElement).pipe(throttleTime(100, null, {
              leading: true,
              trailing: true
            })).subscribe(() => {
              // Search for external viewport
              viewportElement = this.scrollbar.nativeElement.querySelector(externalViewport);
              // Search for external content wrapper
              contentWrapperElement = this.scrollbar.nativeElement.querySelector(externalContentWrapper);
              this.zone.run(() => {
                if (!init && viewportElement && contentWrapperElement) {
                  // If an external spacer selector is provided, search for it
                  let spacerElement;
                  if (externalSpacer) {
                    spacerElement = this.scrollbar.nativeElement.querySelector(externalSpacer);
                  }
                  this.scrollbar.initialize(viewportElement, contentWrapperElement, spacerElement);
                } else if (!viewportElement || !contentWrapperElement) {
                  this.scrollbar.viewport.reset();
                }
              });
              if (asyncDetection !== 'auto') {
                sub$.unsubscribe();
              }
            });
          });
          onCleanup(() => sub$?.unsubscribe());
        });
      });
    }
    static {
      this.ɵfac = function AsyncDetection_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AsyncDetection)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AsyncDetection,
        selectors: [["ng-scrollbar", "externalViewport", "", "asyncDetection", ""]],
        inputs: {
          asyncDetection: [1, "asyncDetection"]
        }
      });
    }
  }
  return AsyncDetection;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SyncSpacer = /*#__PURE__*/(() => {
  class SyncSpacer {
    constructor() {
      this.sharedResizeObserver = inject(SharedResizeObserver);
      this.scrollbar = inject(NgScrollbarExt, {
        self: true
      });
      this.zone = inject(NgZone);
      /**
       * A signal used to sync spacer dimension when content dimension changes
       */
      this.spacerDimension = signal({});
      let sub$;
      effect(onCleanup => {
        const spacerElement = this.scrollbar.spacerElement();
        const contentWrapperElement = this.scrollbar.contentWrapperElement();
        const throttleDuration = this.scrollbar.sensorThrottleTime();
        const disableSensor = this.scrollbar.disableSensor();
        untracked(() => {
          if (!disableSensor && contentWrapperElement && spacerElement) {
            // Sync spacer dimension with content wrapper dimensions to allow both scrollbars to be displayed
            this.zone.runOutsideAngular(() => {
              sub$ = getThrottledStream(this.sharedResizeObserver.observe(contentWrapperElement), throttleDuration).pipe(map(entries => filterResizeEntries(entries, contentWrapperElement))).subscribe(() => {
                this.zone.run(() => {
                  // Use animation frame to avoid "ResizeObserver loop completed with undelivered notifications." error
                  requestAnimationFrame(() => {
                    this.spacerDimension.set({
                      width: contentWrapperElement.offsetWidth,
                      height: contentWrapperElement.offsetHeight
                    });
                  });
                });
              });
            });
          }
          onCleanup(() => sub$?.unsubscribe());
        });
      });
    }
    static {
      this.ɵfac = function SyncSpacer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SyncSpacer)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SyncSpacer,
        selectors: [["ng-scrollbar", "externalViewport", "", "syncSpacer", ""]],
        hostVars: 4,
        hostBindings: function SyncSpacer_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("--spacer-width", ctx.spacerDimension().width)("--spacer-height", ctx.spacerDimension().height);
          }
        }
      });
    }
  }
  return SyncSpacer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgScrollbarModule = /*#__PURE__*/(() => {
  class NgScrollbarModule {
    static {
      this.ɵfac = function NgScrollbarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgScrollbarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgScrollbarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return NgScrollbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideScrollbarOptions(options) {
  return [{
    provide: NG_SCROLLBAR_OPTIONS,
    useValue: {
      ...defaultOptions,
      ...options
    }
  }];
}
function provideScrollbarPolyfill(url) {
  return makeEnvironmentProviders([{
    provide: NG_SCROLLBAR_POLYFILL,
    useValue: url
  }]);
}

/**
 * Generated bundle index. Do not edit.
 */

export { AsyncDetection, NG_SCROLLBAR, NG_SCROLLBAR_OPTIONS, NG_SCROLLBAR_POLYFILL, NgScrollbar, NgScrollbarExt, NgScrollbarModule, ScrollViewport, ScrollbarUpdateReason, SyncSpacer, filterResizeEntries, provideScrollbarOptions, provideScrollbarPolyfill };
